import { erroPeriodoConsulta } from '../../../core/tools/periodo-consulta';
import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../../core/tools/animacao';
import { ExcelService } from '../../../core/tools/excel.service';
import { Vendedor } from '../../../core/models/vendedores/vendedor';
import {
  DashboardB2BGestaoAcesso,
  DashboardB2BGestaoComparativo,
  DashboardB2BGestaoDia,
  DashboardB2BGestaoService
} from '../../../core/services/dashboard/b2b-gestao/dashboard-b2b-gestao.service';
import { VendedorService } from '../../../core/services/vendedores/vendedor.service';

@Component({
  selector: 'app-dashboard-b2b-gestao',
  templateUrl: './dashboard-b2b-gestao.component.html',
  styleUrls: ['./dashboard-b2b-gestao.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class DashboardB2BGestaoComponent implements OnInit {
  erroPeriodo = '';
  carregando: boolean = false;

  vendedorFiltro: string = '';
  vendedorFiltroId: number = null;
  filtroAtivo: string = '';
  dataInicio: string;
  dataFim: string;

  vendedoresPesquisa: Vendedor[] = [];
  dias: DashboardB2BGestaoDia[] = [];
  vendedores: DashboardB2BGestaoComparativo[] = [];
  estados: DashboardB2BGestaoComparativo[] = [];
  cidades: DashboardB2BGestaoComparativo[] = [];
  acessos: DashboardB2BGestaoAcesso[] = [];

  totalAcessos: number = 0;
  totalPedidos: number = 0;
  conversaoGeral: number = 0;

  maxVendedores: number = 0;
  maxEstados: number = 0;
  maxCidades: number = 0;

  constructor(
    private dashboardB2BGestaoService: DashboardB2BGestaoService,
    private excelService: ExcelService,
    private vendedorService: VendedorService
  ) {
    const hoje = new Date();
    this.dataInicio = this.formatarDataApi(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 6));
    this.dataFim = this.formatarDataApi(hoje);
  }

  ngOnInit() {
    this.carregarVendedores();
    this.atualizar();
  }

  atualizar() {
    this.erroPeriodo = erroPeriodoConsulta(this.dataInicio, this.dataFim);
    if (this.erroPeriodo) return;

    this.carregando = true;

    this.dashboardB2BGestaoService.getResumo({
      userId: parseInt(localStorage.getItem('id')),
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
      vendedor: this.vendedorFiltro,
      sellerId: this.vendedorFiltroId
    }).subscribe(resumo => {
      this.totalAcessos = resumo.totalAcessos || 0;
      this.totalPedidos = resumo.totalPedidos || 0;
      this.conversaoGeral = resumo.conversaoGeral || 0;
      this.dias = resumo.dias || [];
      this.vendedores = resumo.vendedores || [];
      this.estados = resumo.estados || [];
      this.cidades = resumo.cidades || [];
      this.acessos = resumo.acessos || [];
      this.maxVendedores = this.obterMaximo(this.vendedores);
      this.maxEstados = this.obterMaximo(this.estados);
      this.maxCidades = this.obterMaximo(this.cidades);
      this.carregando = false;
    }, () => {
      this.carregando = false;
    });
  }

  limparFiltros() {
    const hoje = new Date();
    this.dataInicio = this.formatarDataApi(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 6));
    this.dataFim = this.formatarDataApi(hoje);
    this.vendedorFiltro = '';
    this.vendedorFiltroId = null;
    this.filtroAtivo = '';
    this.atualizar();
  }

  vendedoresFiltrados(): Vendedor[] {
    const termo = (this.vendedorFiltro || '').toLowerCase().trim();

    if (termo.length < 2) {
      return [];
    }

    return this.vendedoresPesquisa
      .filter(v => (v.fullname || '').toLowerCase().indexOf(termo) > -1)
      .slice(0, 12);
  }

  selecionarVendedor(vendedor: Vendedor) {
    this.vendedorFiltro = vendedor.fullname;
    this.vendedorFiltroId = vendedor.id;
    this.filtroAtivo = 'vendedor';
  }

  limparVendedor() {
    this.vendedorFiltro = '';
    this.vendedorFiltroId = null;
    this.filtroAtivo = '';
  }

  largura(valor: number, maximo: number): number {
    if (maximo <= 0) {
      return 0;
    }

    return Math.max((valor / maximo) * 100, 6);
  }

  larguraPedidosDia(dia: DashboardB2BGestaoDia): number {
    if (!dia || dia.acessos <= 0) {
      return dia && dia.pedidos > 0 ? 100 : 0;
    }

    return Math.min((dia.pedidos / dia.acessos) * 100, 100);
  }

  larguraSemPedidoDia(dia: DashboardB2BGestaoDia): number {
    if (!dia || dia.acessos <= 0) {
      return 0;
    }

    return Math.max(100 - this.larguraPedidosDia(dia), 0);
  }

  exportarAcessosExcel() {
    const dados = (this.acessos || []).map(acesso => ({
      'Cod ERP': acesso.codigoErp || '',
      'Nome': acesso.nome || '',
      'Cidade': acesso.cidade || '',
      'Estado': acesso.estado || '',
      'Vendedor': acesso.vendedor || '',
      'Data de acesso': this.formatarDataHora(acesso.dataAcesso)
    }));

    this.excelService.exportAsExcelFile(dados, 'Relatorio de acessos B2B');
  }

  private carregarVendedores() {
    this.vendedorService.getByUsuario().subscribe(
      vendedores => this.vendedoresPesquisa = vendedores || [],
      () => this.vendedoresPesquisa = []
    );
  }

  private obterMaximo(itens: DashboardB2BGestaoComparativo[]): number {
    return Math.max(0, ...itens.map(item => Math.max(item.acessos, item.pedidos)));
  }

  get dataMaxima(): string {
    return this.formatarDataApi(new Date());
  }

  private formatarDataApi(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  private formatarDataHora(valor: any): string {
    if (valor == null || valor === '') {
      return '';
    }

    const data = new Date(valor);

    if (isNaN(data.getTime())) {
      return valor.toString();
    }

    const dia = data.getDate().toString().padStart(2, '0');
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const ano = data.getFullYear();
    const hora = data.getHours().toString().padStart(2, '0');
    const minuto = data.getMinutes().toString().padStart(2, '0');
    const segundo = data.getSeconds().toString().padStart(2, '0');

    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
  }

  private parseData(valor: string): Date {
    if (!valor) {
      return null;
    }

    const partes = valor.split('-').map(item => parseInt(item, 10));
    if (partes.length != 3 || partes.some(item => isNaN(item))) {
      return null;
    }

    return new Date(partes[0], partes[1] - 1, partes[2]);
  }
}
